import React from 'react';
import useIsMobile from '@hooks/useIsMobile';
import useYotpoWidgets from '@hooks/useYotpoWidgets';

type ReviewsProps = {
  productId: number | undefined;
  hideReviews?: boolean;
  hideReviewsHeader?: boolean;
};

export default function Reviews({
  productId,
  hideReviews = false,
  hideReviewsHeader = false,
}: ReviewsProps) {
  useYotpoWidgets();
  const isMobile = useIsMobile();
  return (
    <>
      <div className="flex flex-col gap-6" style={{ display: hideReviews ? 'flex' : 'none' }}>
        {!isMobile ? <span className="text-2xl font-rp-gelica-light">Reviews</span> : ''}
        <span className="text-lg text-center">Not enough reviews yet</span>
      </div>
      <div
        className={`yotpo-widget-instance ${hideReviewsHeader ? 'hide-reviews-header' : ''}`}
        style={{ display: !hideReviews ? 'block' : 'none' }}
        data-yotpo-instance-id={process.env.NEXT_PUBLIC_YOTPO_REVIEWS_INSTANCE_ID}
        data-yotpo-product-id={productId}
      />
    </>
  );
}
